import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/api-reference.md';
import Alerts from '/src/pages/documentation/resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "signal-api-reference"
    }}>{`Signal API reference`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <h2 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`extensionVersion()`}</inlineCode>{` API returns the version of the Signal extension that is registered with the Mobile Core extension.`}</p>
    <p>{`To get the version of the Signal extension, use the following code sample:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=extension-version" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=extension-version" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&api=extension-version" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&api=extension-version" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&api=extension-version" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&api=extension-version" mdxType="Tabs" />
    <h2 {...{
      "id": "registerextension"
    }}>{`registerExtension`}</h2>
    <p>{`Registers the Signal extension with the Mobile Core.`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&api=extension-version" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&api=register-extension" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&api=register-extension" mdxType="Tabs" />
    <h2 {...{
      "id": "collectpii"
    }}>{`collectPII`}</h2>
    <p>{`The Signal extension can be used to handle `}<inlineCode parentName="p">{`collectPII`}</inlineCode>{` rules. For more information, see the `}<a parentName="p" {...{
        "href": "../api-reference.md#collectpii"
      }}>{`collectPII`}</a>{` API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      